import { Box } from '@mui/material'
import { Clock16Regular } from '@/components/Icon'
import ThreadListRow from './ThreadListRow'
import styles from './HomeNavThreadList.module.scss'

export function HomeNavThreadList({
  threads,
  selectedThreadId,
  onSelectThread,
  onThreadMenuAction,
  onRenameThread,
  density = 'compact',
  showChatIcon = false,
  scrollable = false,
  menuSurface = 'threads',
  ariaLabel = 'Threads',
  // Chats carrying a schedule get a clock instead of the default chat glyph, so
  // they stay listed here yet remain distinguishable at a glance.
  scheduledThreadIds,
}) {
  if (!threads.length) return null

  const listClassName = scrollable ? `${styles.list} ${styles.scrollList}` : styles.list

  return (
    <Box component="ul" className={listClassName} aria-label={ariaLabel}>
      {threads.map((thread) => {
        const isScheduled = Boolean(scheduledThreadIds?.has(thread.id))
        return (
          <Box component="li" key={thread.id} className={styles.listItem}>
            <ThreadListRow
              title={thread.title}
              thread={thread}
              menuSurface={menuSurface}
              active={thread.id === selectedThreadId}
              onClick={() => onSelectThread?.(thread)}
              onThreadMenuAction={onThreadMenuAction}
              onRenameThread={onRenameThread}
              density={density}
              showChatIcon={isScheduled ? false : showChatIcon}
              LeadingIcon={isScheduled ? Clock16Regular : undefined}
            />
          </Box>
        )
      })}
    </Box>
  )
}
